import request from '@/utils/request'
export function pageList(params) {
    return request({
        url:'/system/tbMessageRemind/page',
        method: 'get',
        params:params
    })
}
export function save(data){
    return request({
        url:'/system/tbMessageRemind',
        method:'POST',
        data:data
    })
}
// export function deleteMessage(id) {
//     return request({
//         url:'/system/tbMessageRemindDel',
//         method: 'get',
//         params: {id:id}
//     })
// }

export function deleteMessage(id) {
    return request({
        url:`/system/tbMessageRemind/${id}`,
        method: 'delete'
    })
}

export function selectMessageList(params){
    return request({
        url:'/system/tbMessageRemind',
        method: 'get',
        params:params
    })
}
export function editMessageRemind(params){
    return request({
        url:'/system/tbMessageRemindEdit',
        method: 'get',
        params:params
    })
}